// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2dVUb","requiredAsterisk":"Info_requiredAsterisk__3OKKz"};